import { Box, Text, Flex } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import PrimaryButton from "components/Button/PrimaryButton";
import DadosDeEndereco from "ui/components/FormEndereco";
import { showErrorAxios } from "infra/helpers/alerta";
import useEndereco from "core/features/parceiros/hooks/useEnderecoParceiro";
import { useEffect } from "react";
import { useLoading } from "ui/components/GlobalLoading";
import useSaveEndereco from "core/features/parceiros/hooks/useSaveEnderecoParceiro";
import { ParceiroEndereco } from "core/features/parceiros/typings/index";

interface FormEndereco {
  endereco: ParceiroEndereco;
}

function Endereco({ idParceiro }: { idParceiro: string }) {
  const { data, isLoading, isFetching, refetch } = useEndereco(idParceiro);

  const { mutate: handleSave, isLoading: isLoadingSave } =
    useSaveEndereco(idParceiro);

  const { control, reset, handleSubmit, watch, setValue } =
    useForm<FormEndereco>({});

  useEffect(() => {
    if (data) {
      reset({ endereco: data });
    }
  }, [data, reset]);

  const onSubmit = async (data: FormEndereco) => {
    handleSave(data.endereco, {
      onSuccess: refetch,
      onError: (e) => {
        showErrorAxios(e);
      },
    });
  };

  useLoading(isLoading);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box mb={8}>
          <Text fontSize="18px" fontWeight="bold">
            Endereço
          </Text>
        </Box>
        <DadosDeEndereco
          control={control}
          setField={setValue}
          watch={watch}
          showMap
        />
        <Flex justifyContent={"flex-end"} mt="32px">
          <PrimaryButton type="submit" isLoading={isLoadingSave || isFetching}>
            Salvar
          </PrimaryButton>
        </Flex>
      </form>
    </>
  );
}

export default Endereco;
